import {FORM_NAME, FORM_TYPE, SUBMIT_ERROR, SUBMIT_FORM} from 'state/actions/types'
import {always, has, prop, when} from 'ramda'

import {formType} from 'state/reducers/reduce/formType'
import {submitError} from 'state/reducers/reduce/submitError'
import {submitForm} from 'state/reducers/reduce/submitForm'
import {thunk} from 'utils/fp'
import {updateForm} from 'state/reducers/reduce/updateForm'

export type DefaultState = {
	readonly appType: string
	readonly email: string
	readonly message: string
	readonly name: string
	readonly submitted: boolean
	readonly error: boolean
}

type Action = {
	readonly id: string
	readonly payload: string
	readonly type: string
}

export type FormReducer = (state: any, action: Action) => any

const defaultState: DefaultState = {
	appType: 'App',
	email: '',
	message: '',
	name: '',
	submitted: false,
	error: false,
}

const dispatchTable: Record<string, any> = {
	[FORM_NAME]: updateForm,
	[FORM_TYPE]: formType,
	[SUBMIT_ERROR]: submitError,
	[SUBMIT_FORM]: submitForm,
}

export const formReducer: FormReducer = (state = defaultState, action) => {
	const exists = always(has(action.type, dispatchTable))
	const execute = thunk(prop(action.type, dispatchTable))(state, action)

	return when(exists, execute)(state)
}
